import { Directive, inject, Input } from '@angular/core';
import { FormGroup, NG_ASYNC_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { NetzbetreiberService } from '../../service/netzbetreiber/netzbetreiber.service';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { UniqueTeilgebietAndNetzbetreibernummer } from '../../domain/model/netzbetreiber';
import { ControlConfig } from '../../erzeugungsanlage/erzeugungsanlage-form/form-config.model';

@Directive(
    {
        selector: '[redispatchUniqueTeilgebietAndNetzbetreibernummer]',
        providers: [
            {
                provide: NG_ASYNC_VALIDATORS,
                useExisting: UniqueTeilgebietAndNetzbetreibernummerDirective,
                multi: true,
            },
        ],
        standalone: false,
    },
)
export class UniqueTeilgebietAndNetzbetreibernummerDirective<T extends FormGroup<ControlConfig<UniqueTeilgebietAndNetzbetreibernummer>>> implements Validator {

    @Input('redispatchUniqueTeilgebietAndNetzbetreibernummer') config: {
        originalNetzbetreiberValues: UniqueTeilgebietAndNetzbetreibernummer,
        enabled: boolean
    };

    private netzbetreiberService = inject(NetzbetreiberService);

    validate(formGroup: T): Observable<ValidationErrors | null> | ValidationErrors {
        {
            if (!this.config?.enabled) {
                return of(null);
            }

            if (!formGroup.value || !this.config?.originalNetzbetreiberValues) {
                return of(null);
            }

            if (
                this.config?.originalNetzbetreiberValues.teilgebiet === formGroup.value.teilgebiet &&
                this.config?.originalNetzbetreiberValues.netzbetreibernummer === formGroup.value.netzbetreibernummer
            ) {
                return of(null);
            }

            return this.netzbetreiberService.getAlleUniqueTeilgebietAndNetzbetreibernummer(formGroup.getRawValue())
                .pipe(
                    map(nb => {
                        return (nb.length > 0)
                            ? { 'uniqueTeilgebietName': true }
                            : null;
                    }),
                );
        }
    }
}
